export default __webpack_public_path__ + "static/media/game-package.1723ccbb.svg";